module.exports = __webpack_public_path__ + "img/la.b76f93a9.svg";